import { render, staticRenderFns } from "./teamMallOrder.vue?vue&type=template&id=517b50de&scoped=true"
import script from "./teamMallOrder.vue?vue&type=script&lang=js"
export * from "./teamMallOrder.vue?vue&type=script&lang=js"
import style0 from "./teamMallOrder.vue?vue&type=style&index=0&id=517b50de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b50de",
  null
  
)

export default component.exports